import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from '~app/app.component';
import { appRoutes } from '~app/app.routes';
import { UnauthorizedInterceptor } from '~app/interceptors/unauthorized.interceptor';

import { environment } from 'src/environments/environment';


if (environment.production) enableProdMode();

registerLocaleData(localeFr);

bootstrapApplication(AppComponent, {
	providers: [
		provideHttpClient(withInterceptorsFromDi(), withXhr()),
		provideRouter(appRoutes),
		provideServiceWorker('ngsw-worker.js', {
			enabled: environment.env !== 'DEVELOPMENT',
			registrationStrategy: 'registerWhenStable:5000',
		}),
		provideZoneChangeDetection(),
		provideTranslateService({
			loader: provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
		}),
		{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
		{ provide: LOCALE_ID, useValue: 'fr-FR' },
		{ provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
	],
})
	.catch(console.error);
